import { sharedCareScoutQuestions } from './careScoutAppSharedQuestions';
import { sharedCareScoutSections } from './careScoutAppSharedSections';

// Export sections as an object with camelCase keys matching their IDs
export const careScoutILFormDefinition: PolicyFormDefinition = {
  sections: [
    sharedCareScoutSections.coverageSelection,
    sharedCareScoutSections.eftPaymentAuth,
    sharedCareScoutSections.applicantProfile,
    sharedCareScoutSections.insurabilityProfile,
    sharedCareScoutSections.medicalQuestions,
    sharedCareScoutSections.socialHistory,
    sharedCareScoutSections.familyHistory,
    sharedCareScoutSections.otherCoverage,
    sharedCareScoutSections.protectionLapse,
    sharedCareScoutSections.producerSignature,
    sharedCareScoutSections.ltcAppOverflowForm,
    sharedCareScoutSections.healthInsuranceAuthorization,
    sharedCareScoutSections.ltcInsurancePersonalWorksheet,
    sharedCareScoutSections.verificationFinancialNonDisclosure,
    sharedCareScoutSections.ltcPotentialRateIncreaseDisclosure,
    sharedCareScoutSections.licensedInsuranceProducerInformation,
  ],
  questions: {
    ...sharedCareScoutQuestions,
    premiumAmount: {
      id: 'premium-amount',
      questionRef: 'premiumAmount',
      title: 'What is your premium?',
      type: 'text',
      required: true,
      validationType: 'currency',
    },
  },
};
